$(document).ready(function () {

  /**
* Slider Accessibility Helper
*/
  const toggleInnerFocus = (slider) => {
    const focusableElements = ['iframe', 'input', 'select', 'option', 'textarea', 'button', 'video', 'label', 'a', '.plyr', 'model-viewer'];
    focusableElements.forEach((fosusableElement) => {
      slider.slides.forEach((slide, index) => {
        if (index === slider.activeIndex) {
          if (fosusableElement === '.plyr') {
            slide.querySelector(fosusableElement)?.setAttribute('tabindex', '0');
          } else {
            slide.querySelectorAll(fosusableElement).forEach((elem) => {
              elem?.removeAttribute('tabindex');
            });
          }
        } else {
          slide.querySelectorAll(fosusableElement).forEach((elem) => {
            elem?.setAttribute('tabindex', '-1');
          });
        }
      });
    });
  };

  const slideToSlide = (slider, slideIndex, transition) => {
    if (transition) {
      slider.slideTo(slideIndex);
    } else {
      slider.slideTo(slideIndex, 0);
    }
  }


  // -------------------------------------
  // Carousel Products
  // -------------------------------------



  // const productThumbnailSwiper = new Swiper(`.slider-nav`, {
  //   // Optional parameters
  //   slidesPerView: 5.5,
  //   spaceBetween: 4,
  //   freeMode: true,
  //   watchSlidesProgress: true,
  //   navigation: true,
  //   keyboard: {
  //     enabled: false
  //   },
  //   a11y: false,
  //   breakpoints: {
  //     // when window width is >= 1024px
  //     1024: {
  //       // direction: 'vertical',
  //       slidesPerView: 7,
  //       spaceBetween: 10,
  //     }
  //   },
  //   multipleActiveThumbs: false
  // });

  function debounce(func, wait = 200) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        requestAnimationFrame(() => func.apply(context, args));
      }, wait);
    };
  }

  let productFeatureSwiper = null;
  let productThumbnailSwiper = null;
  const breakpoint = 768;


  function initThumbnailSwiper() {
    const direction = document.querySelector('.slider-nav').dataset.direction;

    productThumbnailSwiper = new Swiper('.slider-nav', {
      slidesPerView: 5.5,
      spaceBetween: 4,
      freeMode: true,
      watchSlidesProgress: true,
      navigation: true,
      breakpoints: {
        1024: {
          direction: direction || 'horizontal',
          slidesPerView: 7,
          spaceBetween: 10
        }
      },
      keyboard: {
        enabled: false
      },
      a11y: false,
    });
  }

  function initProductFeatureSwiper() {
    productFeatureSwiper = new Swiper('.slider-for', {
      spaceBetween: 0,
      slidesPerView: 1,
      loop: true,
      thumbs: {
        swiper: productThumbnailSwiper,
      },
      breakpoints: {
        1024: {
          slidesPerView: 1,
        }
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }

  function handleSwiperResize() {
    const oldPdpSlider = document.querySelector('.slider-nav[data-direction="vertical"]');
    if (oldPdpSlider) {
      initThumbnailSwiper();
      initProductFeatureSwiper();
      return
    }

    if (window.innerWidth > breakpoint) {
      if (productFeatureSwiper) {
        productFeatureSwiper.destroy(true, true);
        productFeatureSwiper = null;
      }
      if (productThumbnailSwiper) {
        productThumbnailSwiper.destroy(true, true);
        productThumbnailSwiper = null;
      }
    } else {
      if (!productThumbnailSwiper) {
        initThumbnailSwiper();
      }
      if (!productFeatureSwiper) {
        initProductFeatureSwiper();
      }
    }
  }

  // Initial load
  handleSwiperResize();

  // Debounced resize listener
  window.addEventListener('resize', debounce(handleSwiperResize, 500));


  // Fancybox Zoom

  // Fancybox is only loaded on product pages
  if (window.Fancybox) Fancybox.bind("[data-fancybox]", {
    // Your custom options
    openEffect: 'none',
    closeEffect: 'none',
    afterShow: function () {
      document.querySelector('.fancybox-button--zoom').click();
    }
  });

  $('.home-page__container .homepage-hero').css('opacity', '1');
  //   if($(window).width() > 1023){
  //      var next_slider = setInterval(function(){
  //        $('.homepage-hero__container .product-image__thumbnail-image-next').click();
  //     },6600);
  //   }

  $('.blog-look-book .title-drop-mobile').click(function () {
    if ($('.blog-look-book .box-list-drop').hasClass('active')) {
      $('.blog-look-book .box-list-drop').removeClass('active');
      $('.blog-look-book .drop-down-mobile .title-drop-mobile').removeClass('active');
    } else {
      $('.blog-look-book .box-list-drop').addClass('active');
      $('.blog-look-book .drop-down-mobile .title-drop-mobile').addClass('active');
    }
  });
  $(".blog-look-book .item-category").mouseover(function () {
    $(".blog-look-book .item-category.active").css("background-color", "#fafafa");
  });
  $(".blog-look-book .item-category").mouseout(function () {
    $(".blog-look-book .item-category.active").css("background-color", "var(--pink)");
  });
  $(".blog-look-book .item-category.active").mouseover(function () {
    $(this).css("background-color", "var(--pink)");
  });
  $(".careers-view-open-position").click(function () {
    $('html, body').animate({
      scrollTop: $("#careers-open-position").offset().top - 150
    }, 2000);
  });

  //Live Consultation
  const live_consultation_card = document.getElementsByClassName("card how live-consultation");
  const live_consultation_row = document.getElementsByClassName("row-img-and-desc live-consultation");
  for (let i = 0; i < live_consultation_card.length; i++) {
    $(live_consultation_card[i]).click(function () {
      $('html, body').animate({
        scrollTop: $(live_consultation_row[i]).offset().top - 150
      }, 2000);
    });
  }

});



$('.dib-prod-form').on('submit', function (event) {
  event.preventDefault(); // prevent default form submission
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(this).serialize(),
    dataType: 'json',
    success: function (event) {
      ajaxCart.load();
    },
    error: function () {
      null
    }
  });
});


// Product Review
document.addEventListener("DOMContentLoaded", function (event) {
  let tab_review = document.querySelector(".tab-review-question #tab-review");
  let review_content = document.querySelector("#pr-reviewdisplay.tab_content");
  let tab_question = document.querySelector(".tab-review-question #tab-question");
  let question_content = document.querySelector("#pr-questiondisplay.tab_content");

  function openReviewsTab() {
    if (tab_question.classList.contains('active')) {
      tab_question.classList.remove('active');
      question_content.classList.remove('active');
    }

    if (!tab_review.classList.contains('active')) {
      tab_review.classList.add('active');
      review_content.classList.add('active');
    }

    review_content.scrollIntoView({
      behavior: "smooth"
    });
  }

  function openQuestionsTab() {
    if (tab_review.classList.contains('active')) {
      tab_review.classList.remove('active');
      review_content.classList.remove('active');
    }

    if (!tab_question.classList.contains('active')) {
      tab_question.classList.add('active');
      question_content.classList.add('active');
    }

    question_content.scrollIntoView({
      behavior: "smooth"
    });
  }

  // Open Reviews tab
  if (tab_review) {
    tab_review.addEventListener('click', openReviewsTab);
  }
  $(document).on('click', '.bv_war_button', openReviewsTab);

  // Open Questions tab
  if (tab_question) {
    tab_question.addEventListener('click', openQuestionsTab);
  }
  $(document).on('click', '.bv_aaq_button', openQuestionsTab);
});

